import { render } from "./p-tree.vue?vue&type=template&id=4af8282b&scoped=true"
import script from "./p-tree.vue?vue&type=script&lang=js"
export * from "./p-tree.vue?vue&type=script&lang=js"

import "./p-tree.vue?vue&type=style&index=0&id=4af8282b&scoped=true&lang=scss"
import "./p-tree.vue?vue&type=style&index=1&id=4af8282b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af8282b"]])

export default __exports__